import BasicButton from "../../../components/Buttons/BasicButton";
import XsCont from "../../../components/containers/Xs";
import HeaderWithoutSignIn from "../../../components/headers/HeaderWithoutSignIn";
import { Box, Container, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const PasswordChangeCompletePage: React.FC = () => {
  const navigate = useNavigate();
  const handleClickButton = () => {
    navigate("/signin");
  };
  return (
    <>
      <HeaderWithoutSignIn />
      <Container maxWidth={"xl"}>
        <Box textAlign="center" mt={15}>
          <Typography variant="h5" gutterBottom>
            パスワード変更完了
          </Typography>
        </Box>
        <Box mt={10} textAlign="center">
          <Typography variant="body1" gutterBottom>
            パスワード変更完了をしました。
            <br />
            再度サインインしてください。
          </Typography>
        </Box>
      </Container>
      <XsCont>
        <BasicButton onClick={handleClickButton} mt={10}>
          サインイン
        </BasicButton>
      </XsCont>
    </>
  );
};

export default PasswordChangeCompletePage;
